import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createCoupon } from '../api/coupon'; 
import RegistarLayout from '../components/RegistarLayout';
import InputFormLayout from '../components/InputFormLayout';
import RegistarButtonLayout from '../components/RegistarButtonLayout';
import './CouponRegister.css'

export default function CouponCreate() {
  const [code, setCode] = useState('');
  const [discountType, setDiscountType] = useState('percent'); // percent or amount
  const [discountValue, setDiscountValue] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [durationInMonths, setDurationInMonths] = useState('');
  const [unlimitedMessage, setUnlimitedMessage] = useState('');
  const [redeemBy, setRedeemBy] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      if (durationInMonths === 0){
        setDurationInMonths(null);
      }

      let duration = null;
      if (durationInMonths === 1){
        duration = 'once';
      }else if (durationInMonths > 1){
        duration = 'repeating';
      }else{
        duration = 'forever';
      }

      const payload = {
        name,
        code,
        discount_type: discountType,
        discount_value: parseInt(discountValue),
        duration: duration,
        duration_in_months: durationInMonths,
        unlimited_message: unlimitedMessage,
        redeem_by: redeemBy,
      };

      await createCoupon(payload);

      setMessage('クーポンを作成しました！');

      // フォームリセット
      setName('');
      setCode('');
      setDiscountType('percent');
      setDiscountValue('');
      setDurationInMonths('');
      setUnlimitedMessage('');
      setRedeemBy('');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'クーポン作成に失敗しました');
    }
  };

  return (
    <RegistarLayout title="クーポン作成" margin="0px auto" marginTop="5vh">

      {message && <div style={{ color: 'green' }}>{message}</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}

      
      <InputFormLayout
          id="CouponName"
          labelTitle="クーポン名"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="例：春のキャンペーン"
        />

        <InputFormLayout
          id="CouponCode"
          labelTitle="クーポンコード"
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="例：SPRING2025"
        />


        <div className="discount-row">
          <div className="discount-field">
            <InputFormLayout
              id="Discount"
              labelTitle="割引"
              type="number"
              value={discountValue}
              onChange={(e) => setDiscountValue(e.target.value)}
              placeholder={discountType === 'percent' ? '例: 20' : '例: 500'}
            />
          </div>

          <div className="discount-field">
            <select
              value={discountType}
              onChange={(e) => setDiscountType(e.target.value)}
              className="discount-select"
            >
              <option value="percent">％</option>
              <option value="amount">円</option>
            </select>
          </div>
        </div>

          <InputFormLayout
            id="duration"
            labelTitle="クーポン期間(月)"
            type="number"
            value={durationInMonths ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setDurationInMonths(value === '' ? null : Number(value));
            }}
            placeholder="例: 1"
          />

        {(!durationInMonths || durationInMonths === 0) && (
        <InputFormLayout
          id="Couponmessage"
          labelTitle="期間指定がない時のメッセージ"
          type="text"
          value={unlimitedMessage}
          onChange={(e) => setUnlimitedMessage(e.target.value)}
          placeholder="例: 共済会員の間"
        />
        )}
        
        <InputFormLayout
          id="date"
          labelTitle="有効期限"
          type="date"
          value={redeemBy}
          onChange={(e) => setRedeemBy(e.target.value)}
        />

        <div className="couponButtons">
          <RegistarButtonLayout
            buttonTitle="登録"
            type="submit"
            onClick={handleSubmit}
          />
          <RegistarButtonLayout
            buttonTitle="クーポン管理に戻る"
            type="button"
            onClick={() => navigate('/coupon-management')}
          />
          <RegistarButtonLayout
            buttonTitle="企業ポータルに戻る"
            type="button"
            onClick={() => navigate('/implpage')}
          />
        </div>

      </RegistarLayout>
  );
}